import React, { Suspense } from "react";
import { Switch } from "react-router-dom";
import { UsersPage } from "./pages/UsersPage";
import { LayoutSplashScreen, ContentRoute } from "../../../_metronic/layout";

export default function UsersListPage() {
    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <Switch>
                <ContentRoute path="/users" component={UsersPage} />
            </Switch>
        </Suspense>
    );
}
